import React from 'react';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { buildMakeYearsPath, VehicleModel } from 'client/data/models/vehicle';
import { sortByYear } from 'site-modules/shared/utils/sorting';
import { getLatestYears } from 'site-modules/shared/utils/date-utils';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';

export function filterYears(years, { showLatestYears }) {
  const sortedYears = years.map(year => ({ year })).sort(sortByYear);

  if (showLatestYears) {
    const latestYears = getLatestYears();
    return sortedYears.filter(({ year }) => latestYears.includes(Number(year)));
  }
  return sortedYears;
}

const stateToPropsConfig = {
  options: bindToPath(({ make }) => make && buildMakeYearsPath(make.slug), VehicleModel, filterYears),
};

const ConnectedStyledYearByMakeDropdown = connectToModel(StyledSelect, stateToPropsConfig);

export function StyledYearByMakeDropdown({
  name = 'select-year',
  toggle = 'Select Year',
  valueKey = 'year',
  labelKey = 'year',
  ...restProps
}) {
  return (
    <ConnectedStyledYearByMakeDropdown
      {...restProps}
      name={name}
      toggle={toggle}
      valueKey={valueKey}
      labelKey={labelKey}
    />
  );
}
